import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Attractions } from "./pages/Attractions";
import { News } from "./pages/News";
import { BlogDetail } from "./pages/BlogDetail";
import { Partner } from "./pages/Partner";
import { AdminLogin } from "./components/AdminLogin";
import { AdminDashboard } from "./components/AdminDashboard";
import { PartnerPortal } from "./components/PartnerPortal";
import { Layout } from "./components/Layout";
import { FAQ } from "./pages/FAQ";
import { TermsAndConditions } from "./pages/TermsAndConditions";
import { RefundPolicy } from "./pages/RefundPolicy";
import { CheckBooking } from "./pages/CheckBooking";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ScrollToTop } from "./components/ScrollToTop";
import { logout as logoutAuth } from "./services/api/auth";

export const App: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutAuth();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        {/* <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        /> */}
        <Route
          path="/attractions"
          element={
            <Layout>
              <Attractions />
            </Layout>
          }
        />
        <Route
          path="/news"
          element={
            <Layout>
              <News />
            </Layout>
          }
        />
        <Route
          path="/news/:slug"
          element={
            <Layout>
              <BlogDetail />
            </Layout>
          }
        />
        <Route
          path="/partner-register"
          element={
            <Layout>
              <Partner />
            </Layout>
          }
        />
        <Route
          path="/faq"
          element={
            <Layout>
              <FAQ />
            </Layout>
          }
        />
        <Route
          path="/terms"
          element={
            <Layout>
              <TermsAndConditions />
            </Layout>
          }
        />
        <Route
          path="/refund"
          element={
            <Layout>
              <RefundPolicy />
            </Layout>
          }
        />
        <Route
          path="/check-booking"
          element={
            <Layout>
              <CheckBooking />
            </Layout>
          }
        />

        <Route
          path="/login"
          element={
            <AdminLogin
              onLogin={() => navigate("/admin")}
              onCancel={() => navigate("/")}
            />
          }
        />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin", "staff", "finance"]}>
              <AdminDashboard onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/partner"
          element={<PartnerPortal onLogout={handleLogout} />}
        />
      </Routes>
    </>
  );
};
